import React, { createContext, useContext, useEffect, useState } from "react";
import { useGetAddress } from "../../hooks/api/fh/useGetAddress";
import { useParams } from "react-router-dom";

const AddressContext = createContext({});

const selectAddressOption = (address) => {
  if (address) {
    return {
      value: address.address_id,
      label: `${address?.address_name} - ${address.address_line_1}, ${address.address_city}, ${address.address_state} ${address.address_postcode}`,
      address,
    };
  }
  return null;
};

export const AddressContextProvider = ({ children }) => {
  const { home } = useParams();
  const [fdId, setFdId] = useState(null);
  const { data, isLoading } = useGetAddress(fdId ?? home);
  const [selectedAddress, setSelectedAddress] = useState();

  const getDefaultAddress = () => {
    const defaultAddress = data?.find((address) => address.is_default === "1");
    if (defaultAddress) {
      return defaultAddress;
    }
    return data?.[0] || null;
  };

  const selectOptions = () => {
    if (!data) return [];
    return data.map(selectAddressOption);
  };

  useEffect(() => {
    // Select the Default address by default
    if (data && data.length > 0) {
      const defaultAddress = getDefaultAddress();
      setSelectedAddress(selectAddressOption(defaultAddress));
    }
  }, [data]);

  return (
    <AddressContext.Provider
      value={{
        addresses: data,
        isLoading,
        setFdId,
        selectOptions,
        selectedAddress,
        setSelectedAddress,
      }}
    >
      {children}
    </AddressContext.Provider>
  );
};

export const useAddressContext = () => useContext(AddressContext);
